export const subscriptionAmountValidation = () => {
    return {
        validate: {
            validAmount: (_amount: string) => {
                const amount = Number(_amount)
                if (amount <= 0) {
                    return 'Amount must be greater than zero'
                }
            },
        },
    }
}
